<template>
  <div>
    <div id="chattool" class="text-xs-center">
      <v-tabs v-model="chattooltype" color="grey lighten-3" :slider-color="$vuetify.theme.primary">
        <v-tab ripple :key="'customer'" :href="'#customer'">{{ $t('Info') }}</v-tab>
        <v-tab v-if="selectedBot.theme == 'ticket'" ripple :key="'ticket'" :href="'#ticket'">{{
          $t('Ticket')
        }}</v-tab>
        <v-tab v-if="selectedBot.theme == 'nvbb'" ripple :key="'qouta'" :href="'#qouta'">{{
          $t('Quota')
        }}</v-tab>
        <v-tab
          v-if="selectedBot.theme == 'scgworkplace'"
          ripple
          :key="'workplacecustomer'"
          :href="'#workplacecustomer'"
          >{{ $t('Workplace') }}</v-tab
        >
        <v-tab
          v-if="selectedBot.theme == 'scgallrent' && allrentcustomer && allrentcustomer.length"
          ripple
          :key="'allrentcustomer'"
          :href="'#allrentcustomer'"
          >{{ $t('Customer') }}</v-tab
        >
        <v-tab
          v-if="$store.state.toacustomerpage.includes(selectedBot.pageid)"
          ripple
          :key="'toapaintcustomer'"
          :href="'#toapaintcustomer'"
          >{{ $t('Paint') }}</v-tab
        >
        <v-tab
          v-if="$store.state.toacustomerpage.includes(selectedBot.pageid)"
          ripple
          :key="'toapaintercustomer'"
          :href="'#toapaintercustomer'"
          >{{ $t('Painter') }}</v-tab
        >
        <v-tab
          v-if="selectedBot.theme == 'scgallrent' && allrentsupplier && allrentsupplier.length"
          ripple
          :key="'allrentsupplier'"
          :href="'#allrentsupplier'"
          >{{ $t('Supplier') }}</v-tab
        >
        <!-- <v-tab ripple :key="'conversation'" :href="'#conversation'">{{$t('Conversation')}}</v-tab> -->
      </v-tabs>
    </div>

    <div
      id
      style="overflow-y: auto"
      v-resize="onResizeToolList"
      :style="{ height: toolListHeight + 'px' }"
    >
      <div v-if="chattooltype == 'ticket'">
        <ticket-list
          v-model="selectedUser.userid"
          :key="`ticket_list_${selectedUser.userid}_${selectedUser.type}`"
        ></ticket-list>
      </div>
      <div v-if="chattooltype == 'customer'">
        <livechat-customers
          v-model="selectedUser"
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
        ></livechat-customers>
      </div>
      <div v-if="chattooltype == 'workplacecustomer'">
        <scgworkplace-customer
          v-model="selectedUser.userid"
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
        ></scgworkplace-customer>
      </div>
      <div v-if="chattooltype == 'toapaintcustomer'">
        <ToaPaintCustomer
          v-model="selectedUser.userid"
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
        ></ToaPaintCustomer>
      </div>
      <div v-if="chattooltype == 'toapaintercustomer'">
        <ToaPainterCustomer
          v-model="selectedUser.userid"
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
        ></ToaPainterCustomer>
      </div>
      <div v-if="chattooltype == 'allrentcustomer'">
        <ScgAllrentCustomer
          v-model="selectedUser"
          :userid="selectedUser.userid"
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
        ></ScgAllrentCustomer>
      </div>
      <div v-if="chattooltype == 'qouta'">
        <NvbbQouta
          v-model="selectedUser"
          :userid="selectedUser.userid"
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
        ></NvbbQouta>
      </div>
      <div v-if="chattooltype == 'allrentsupplier'">
        <ScgAllrentSupplier
          v-model="selectedUser"
          :userid="selectedUser.userid"
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
        ></ScgAllrentSupplier>
      </div>
      <div v-else-if="chattooltype == 'conversation'">
        <div class="pa-1 form-control">
          <input type="text" class="form-control" :placeholder="$t('Search')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ScgworkplaceCustomer from './scgworkplace-customer.vue'
import ScgAllrentCustomer from './scgallrent-customer.vue'
import ScgAllrentSupplier from './scgallrent-supplier.vue'
import NvbbQouta from './NvbbQouta.vue'
import LivechatCustomers from './livechat-customers'
import TicketList from './TicketList'
import ToaPaintCustomer from './ToaPaintCustomer.vue'
import ToaPainterCustomer from './ToaPainterCustomer.vue'
import api from '@/api'

export default {
  props: ['selectedUser'],
  components: {
    ScgworkplaceCustomer,
    ScgAllrentCustomer,
    ScgAllrentSupplier,
    NvbbQouta,
    LivechatCustomers,
    TicketList,
    ToaPaintCustomer,
    ToaPainterCustomer,
  },
  data() {
    return {
      chattooltype: 'customer',
      toolListHeight: 0,
      allrentcustomer: [],
      allrentsupplier: [],
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
  },
  mounted() {
    var vm = this
    if (this.selectedBot.theme == 'scgallrent') {
      vm.getallrenttransactionlivechat()
    }
    if (vm.selectedBot.theme == 'scgworkplace') {
      vm.chattooltype = 'workplacecustomer'
    }
    if (vm.selectedBot.theme == 'ticket') {
      // vm.chattooltype = 'ticket'
    }
    vm.onResizeToolList()
  },
  methods: {
    getallrenttransactionlivechat() {
      if (this.selectedUser && this.selectedUser.userid) {
        var data = {
          pageid: this.selectedBot.pageid,
          userid: this.selectedUser.userid,
        }
        api.getallrenttransactionlivechat(data, (err, response) => {
          if (response.responsecode == 200) {
            this.allrentcustomer = response.data
            this.allrentsupplier = response.data2
          }
        })
      }
    },
    onResizeToolList: function () {
      var vm = this
      vm.$nextTick(function () {
        var toolListHeight = 0
        if (document.getElementById('chattool')) {
          toolListHeight = document.getElementById('chattool').clientHeight
        }
        vm.toolListHeight =
          window.innerHeight - document.getElementById('main_toolbar').clientHeight - toolListHeight
      })
    },
  },
  watch: {
    selectedUser: function (newVal, oldVal) {
      var vm = this
      if (newVal != oldVal) {
        if (this.selectedBot.theme == 'scgallrent') {
          vm.getallrenttransactionlivechat()
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/livechat/livechat-chattool.vue